"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryCode = exports.getSupportPhoneNumber = void 0;

var _toLower = _interopRequireDefault(require("lodash/toLower"));

var _get = _interopRequireDefault(require("lodash/get"));

var _has = _interopRequireDefault(require("lodash/has"));

var _store = _interopRequireDefault(require("./../store"));

var _runtimeConfigHelper = require("./runtime-config-helper");

/**
 * Get the api key from the givin name and the current env
 *
 * @static
 * @param {string} name
 * @returns {string} apikey
 *
 * @memberOf PhoneNumberHelper
 */
var getSupportPhoneNumber = function getSupportPhoneNumber() {
  var _billingInfo;

  var phoneNumbers = (0, _runtimeConfigHelper.getRuntimeConfig)()._phoneNumbers;

  var billingInfo = null;

  if ((0, _store["default"])() && (0, _store["default"])().getState()) {
    billingInfo = (0, _store["default"])().getState().auth && (0, _store["default"])().getState().auth.billingInfo || {};
  } // get the key to receive the correct numbers from settings.js


  var key = ((_billingInfo = billingInfo) === null || _billingInfo === void 0 ? void 0 : _billingInfo.hasPrioritySupport) ? 'priority' : 'paid';

  if (billingInfo && billingInfo.countryCode) {
    var userHisCountryCode = (0, _toLower["default"])(billingInfo.countryCode);

    if ((0, _has["default"])(phoneNumbers, "".concat(key, ".").concat(userHisCountryCode))) {
      return (0, _get["default"])(phoneNumbers, "".concat(key, ".").concat(userHisCountryCode));
    }
  }

  return (0, _get["default"])(phoneNumbers, "".concat(key, ".other"));
};

exports.getSupportPhoneNumber = getSupportPhoneNumber;

var getCountryCode = function getCountryCode() {
  var billingInfo = null;

  if ((0, _store["default"])() && (0, _store["default"])().getState()) {
    billingInfo = (0, _store["default"])().getState().auth && (0, _store["default"])().getState().auth.billingInfo || {};
  }

  return billingInfo && billingInfo.countryCode;
};

exports.getCountryCode = getCountryCode;